import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";

import type { VideoType, } from "./channelTypes";

export default function createChannelVideoColumns(
  dateFilters: any,
  handleEdit: (record: VideoType) => void,
  handleDelete: (videoId: number) => void,
): ColumnsType<VideoType> {
  return [
    {
      key: "sort",
      title: "Sort",
      width: 72,
    },
    {
      title: 'Video title',
      dataIndex: 'videoTitle',
      key: 'videoTitle',
      filters: dateFilters,
      sorter: (a, b) => a.videoTitle.localeCompare(b.videoTitle),
      onFilter: (value, record) => record.videoTitle === value,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 120,
      render: (_, record) => (
        <div className="flex gap-4">
          <Button type="link" className="w-9 p-0" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Button type="link" className="w-9 p-0" onClick={() => handleDelete(record.videoId)}>
            Delete
          </Button>
        </div>
      ),
    },
  ];
}